(function () {
  if (customElements.get('dcs-combos')) return;

  class DcsCombos extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.gf-card')).map((el) => ({
        el,
        tabs: (el.dataset.tabs || '').split(' ').filter(Boolean),
        types: (el.dataset.types || '').split(' ').filter(Boolean),
        price: parseInt(el.dataset.price, 10) || 0
      }));
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.chips = Array.from(this.querySelectorAll('[data-chip]'));
      this.priceSelect = this.querySelector('[data-price-select]');
      this.customPriceForm = this.querySelector('[data-custom-price]');
      this.customMin = this.querySelector('[data-price-min]');
      this.customMax = this.querySelector('[data-price-max]');
      this.priceError = this.querySelector('[data-price-error]');
      this.customRange = null;
      this.panel = this.querySelector('.dcs-combos__panel');
      this.empty = this.querySelector('[data-empty]');
      this.status = this.querySelector('[data-status]');

      this.pageSize = 4;
      this.visibleLimit = this.pageSize;
      this.loadMoreWrap = this.querySelector('[data-load-more-wrap]');
      this.querySelector('[data-load-more]')?.addEventListener('click', () => {
        const previousCount = this.visibleLimit;
        this.visibleLimit = this.cards.length;
        this.apply(true, false);
        const newlyShown = this.cards.filter(card => !card.el.hidden)[previousCount];
        newlyShown?.el.querySelector('a')?.focus({ preventScroll: true });
      });

      const selected = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      this.activeTab = selected ? selected.dataset.tab : 'all';
      this.activeTypes = new Set();
      this.activePrice = 'all';

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.tab));
        tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
      });
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.selectType(chip.dataset.chip);
        });
      });
      if (this.priceSelect) this.priceSelect.addEventListener('change', () => this.selectPrice(this.priceSelect.value));
      if (this.customPriceForm) this.customPriceForm.addEventListener('submit', (e) => { e.preventDefault(); this.applyCustomPrice(); });
      const clear = this.querySelector('[data-clear]');
      if (clear) clear.addEventListener('click', () => { this.clearFilters(); this.focusFirstChip(); });
      this.cards.forEach((card) => this.setupCard(card.el));

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => {
          const id = e.detail && e.detail.blockId;
          if (!id || !this.contains(e.target)) return;
          if (this.tabs.some((t) => t.dataset.tab === id)) this.selectTab(id);
          if (this.chips.some((c) => c.dataset.chip === id)) this.selectType(id);
          if (this.priceSelect && Array.from(this.priceSelect.options).some((o) => o.value === id)) this.selectPrice(id);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.readDeepLink();
      this.apply(false);
    }

    disconnectedCallback() {
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    /* Optional deep link: ?type=rice&size=3-combo&price=under-rs-250 (handleized chip / tab / price labels). */
    readDeepLink() {
      const params = new URLSearchParams(window.location.search);
      const slug = (value) => String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const types = (params.get('type') || '').split(',').map(slug);
      const size = slug(params.get('size'));
      types.forEach((type) => {
        const chip = this.chips.find((c) => c.dataset.slug === type && c.dataset.chip !== 'all');
        if (chip) this.activeTypes.add(chip.dataset.chip);
      });
      const price = slug(params.get('price'));
      if (price && this.priceSelect) {
        const option = Array.from(this.priceSelect.options).find((o) => o.dataset.slug === price);
        if (option) this.activePrice = option.value;
      }
      if (size) {
        const tab = this.tabs.find((t) => t.dataset.slug === size);
        if (tab) this.activeTab = tab.dataset.tab;
      }
    }

    onTabKey(e, i) {
      const last = this.tabs.length - 1;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      if (next === null) return;
      e.preventDefault();
      this.selectTab(this.tabs[next].dataset.tab);
      this.tabs[next].focus();
    }

    selectTab(id) {
      if (this.activeTab === id) return;
      this.activeTab = id;
      this.apply(true);
    }

    selectType(id) {
      if (id === 'all') this.activeTypes.clear();
      else if (this.activeTypes.has(id)) this.activeTypes.delete(id);
      else this.activeTypes.add(id);
      this.apply(true);
    }

    selectPrice(id) {
      if (this.activePrice === id) return;
      this.activePrice = id;
      if (this.priceError) this.priceError.textContent = '';
      this.apply(true);
      if (id === 'custom' && this.customMin) this.customMin.focus();
    }

    applyCustomPrice() {
      const min = this.customMin.value === '' ? 0 : Number(this.customMin.value);
      const max = this.customMax.value === '' ? null : Number(this.customMax.value);
      if (!Number.isFinite(min) || min < 0 || (max !== null && (!Number.isFinite(max) || max < min))) {
        this.priceError.textContent = 'Enter a maximum price greater than or equal to the minimum.';
        this.customMax.focus();
        return;
      }
      this.priceError.textContent = '';
      this.customRange = { min: Math.round(min * 100), max: max === null ? null : Math.round(max * 100) };
      this.apply(true);
    }

    clearFilters() {
      this.activeTypes = new Set();
      this.activePrice = 'all';
      this.customRange = null;
      if (this.customPriceForm) this.customPriceForm.reset();
      if (this.priceError) this.priceError.textContent = '';
      this.apply(true);
    }

    focusFirstChip() {
      const target = this.chips[0] || this.priceSelect;
      if (target) target.focus();
    }

    /* Bounds of the active price range in the smallest currency unit; max null = no upper limit. */
    priceRange() {
      if (!this.priceSelect || this.activePrice === 'all') return null;
      if (this.activePrice === 'custom') return this.customRange;
      const option = Array.from(this.priceSelect.options).find((o) => o.value === this.activePrice);
      if (!option) return null;
      return { min: parseInt(option.dataset.min, 10) || 0, max: parseInt(option.dataset.max, 10) || null };
    }

    matches(card, tab, types, range) {
      if (range && (card.price < range.min || (range.max !== null && card.price > range.max))) return false;
      return (tab === 'all' || card.tabs.includes(tab)) && (types.size === 0 || card.types.some((type) => types.has(type)));
    }

    apply(announce, reset = true) {
      if (reset) this.visibleLimit = this.pageSize;
      const range = this.priceRange();
      if (this.customPriceForm) this.customPriceForm.hidden = this.activePrice !== 'custom';
      if (this.priceSelect) {
        this.priceSelect.value = this.activePrice;
        this.priceSelect.classList.toggle('is-active', this.activePrice !== 'all');
      }
      this.tabs.forEach((tab) => {
        const on = tab.dataset.tab === this.activeTab;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && this.panel && this.panel.hasAttribute('role')) this.panel.setAttribute('aria-labelledby', tab.id);
        const count = tab.querySelector('[data-count]');
        if (count) count.textContent = this.cards.filter((c) => this.matches(c, tab.dataset.tab, this.activeTypes, range)).length;
      });
      this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.chip === 'all' ? this.activeTypes.size === 0 : this.activeTypes.has(chip.dataset.chip))));

      const visible = this.cards.filter((c) => this.matches(c, this.activeTab, this.activeTypes, range));
      const shown = visible.slice(0, this.visibleLimit);
      this.cards.forEach((card) => {
        const show = shown.includes(card);
        if (show && card.el.hidden && announce) {
          card.el.classList.remove('dcs-card--enter');
          void card.el.offsetWidth;
          card.el.classList.add('dcs-card--enter');
        }
        card.el.hidden = !show;
      });

      if (this.empty) this.empty.hidden = visible.length > 0;
      if (this.loadMoreWrap) this.loadMoreWrap.hidden = shown.length >= visible.length;
      if (announce && this.status) this.status.textContent = `Showing ${shown.length} of ${visible.length} combos.`;
    }

    setupCard(card) {
      const qty = card.querySelector('.gf-qty__input');
      const addBtn = card.querySelector('.gf-add');
      if (!qty || !addBtn) return;
      card.querySelector('[data-action="decrease"]').addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
      card.querySelector('[data-action="increase"]').addEventListener('click', () => { qty.value = Math.min(99, parseInt(qty.value, 10) + 1); });
      addBtn.addEventListener('click', () => this.add(addBtn, qty));
    }

    /* Same flow as gifting-combos.js, minus the gifting order attributes and the Campaign property. */
    add(addBtn, qty) {
      if (addBtn.disabled) return;
      const text = addBtn.querySelector('.btn-text');
      const quantity = parseInt(qty.value, 10) || 1;
      addBtn.disabled = true;
      addBtn.classList.add('loading');
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id).join(',') : 'cart-icon-bubble';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: addBtn.dataset.variantId, quantity }], sections, sections_url: window.location.pathname })
      })
        .then((r) => r.json())
        .then((json) => {
          if (json.status) throw new Error(json.description || this.dataset.errorLabel);
          if (drawer) {
            drawer.setActiveElement(addBtn);
            drawer.renderContents(json);
          } else {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && json.sections && json.sections['cart-icon-bubble']) {
              bubble.innerHTML = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
            }
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dcs-combos', cartData: json });
          addBtn.classList.remove('loading');
          addBtn.classList.add('is-added');
          text.textContent = this.dataset.addedLabel;
          text.insertAdjacentHTML('beforeend', ' <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>');
          if (this.status) this.status.textContent = this.dataset.addedLabel;
          qty.value = 1;
          setTimeout(() => { text.textContent = this.dataset.addLabel; addBtn.classList.remove('is-added'); addBtn.disabled = false; }, 1400);
        })
        .catch((error) => {
          addBtn.classList.remove('loading');
          addBtn.disabled = false;
          text.textContent = this.dataset.errorLabel;
          if (this.status) this.status.textContent = (error && error.message) || this.dataset.errorLabel;
          setTimeout(() => { text.textContent = this.dataset.addLabel; }, 2000);
        });
    }
  }

  customElements.define('dcs-combos', DcsCombos);
})();
